import * as React from 'react'
import { HeaderContainer } from '@/scopes/common/components/Header'
import { LanguageSwitch } from '@/scopes/common/components/Header/LanguageSwitch'
import styles from './AuthHeader.module.css'

export function AuthHeader() {
  return (
    <HeaderContainer>
      <div className={styles.content}>
        <LanguageSwitch />
      </div>
    </HeaderContainer>
  )
}
